export enum Variant {
  Small = 'Small',
  Default = 'Default',
}
